export const PAGE_PATH = '/profile-update';
